import type { ConversationListItem } from '@kimuno/api-sdk/lib/types/responses/Conversation';
import { Box, Stack, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { palette, spaces } from '../../../../assets/styles/themes/tokens';
import AIAssistantChatHistoryListItem from './AIAssistantChatHistoryListItem';
import {
	type ChatHistoryGroupingConfig,
	DEFAULT_CHAT_HISTORY_GROUPING_CONFIG,
	groupItemsByTimeFrame,
	sortGroupKeys,
} from './utils';

interface AIAssistantChatHistoryListProps {
	items: ConversationListItem[];
	groupingConfig?: ChatHistoryGroupingConfig;
}

const AIAssistantChatHistoryList = ({
	items,
	groupingConfig = DEFAULT_CHAT_HISTORY_GROUPING_CONFIG,
}: AIAssistantChatHistoryListProps) => {
	const { t } = useTranslation();
	const groupedItems = useMemo(
		() => groupItemsByTimeFrame(items, groupingConfig),
		[items, groupingConfig]
	);
	const sortedGroupKeys = useMemo(
		() => sortGroupKeys(Object.keys(groupedItems), groupingConfig),
		[groupedItems, groupingConfig]
	);

	return (
		<Stack sx={{ marginTop: '0!important', padding: spaces.xxs }} spacing={0}>
			{sortedGroupKeys.map((groupKey) => (
				<Box
					sx={{
						marginBottom: spaces.xs,
					}}
					key={groupKey}
				>
					<Box
						sx={{
							width: '100%',
							paddingX: spaces.sm,
							paddingTop: spaces.sm,
							paddingBottom: spaces.xxs,
							color: palette.text.primary,
						}}
					>
						<Typography variant="caption">{t(groupKey)}</Typography>
					</Box>
					{groupedItems[groupKey].map((item) => (
						<AIAssistantChatHistoryListItem key={item.id} data={item} />
					))}
				</Box>
			))}
		</Stack>
	);
};

export default AIAssistantChatHistoryList;
